/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/allas/components/standalone/MoreEpisodes/theme';

export const MoreEpisodesTheme = theme;
